const baseURL = "https://now-acquire-backend.vercel.app/" ;
// const baseURL = "http://localhost:8080/";

export default baseURL;